module.exports = __webpack_public_path__ + "img/组织碳流程图.e92e351d.png";